// src/modules/units/tyres/shared/tyre-vocab.js
//
// Canonical option lists for the tyre subsystem. These were previously trapped
// inside the per-wheel form; the standalone tyre area reads them from here so the
// dropdowns in the Action Capture form and (later) the create/edit form stay in
// one place. Values mirror the per-wheel form exactly, so records written by
// either path use the same vocabulary.

export const TYRE_BRANDS = [
  'Aeolus', 'Apollo', 'Atlas', 'Autogrip', 'Avon', 'Barum', 'BF Goodrich', 'Bridgestone',
  'Continental', 'Coopers', 'Deestone', 'Dunlop', 'Durun', 'Evergreen', 'Falken', 'Firemax',
  'Firestone', 'General', 'Goodride', 'Goodyear', 'Hankook', 'Infinity', 'JK Tyre', 'Kenda',
  'Kumho', 'Lassa', 'Leader', 'LingLong', 'Matador', 'Maxis', 'Michelin', 'Milemaster', 'MRF',
  'Nippon', 'Pirelli', 'Riken', 'Rovelo', 'Sailun', 'Sava', 'Sumitomo', 'Talon', 'Tercelo',
  'Toyo', 'Trelleborg', 'Triangle', 'Uniroyal', 'Velocity', 'Westlake', 'Yokohama', 'Other'
];

export const TYRE_SIZES = [
  '315/80/R22.5', '295/75/R22.5', '11R22.5', '385/65/R22.5', '275/65/R17', '265/70/R17',
  '215/75R17.5', '225/70R19.5', '245/70R17.5', '285/75R24.5', '11R24.5', '255/70R22.5',
  '275/80/R22.5', '435/45R19.5', '445/45R19.5', 'Other'
];

export const TYRE_TYPES = [
  'Super Single', 'Light Truck', 'Commercial Truck', 'Agricultural', 'OTR', 'Other'
];

// export const TYRE_TYPES = [
//   'Premium', 'Economy', 'Super Single', 'Retread/Recap', 'Passenger', 'High Performance',
//   'Light Truck', 'Commercial Tyre', 'Agricultural', 'OTR', 'Other'
// ];

export const TYRE_APPLICATIONS = ['Steer', 'Drive', 'Trailer', 'Casing'];

//export const TYRE_GRADES = ['New', 'RT Grade A', 'RT Grade B', 'Scrapped', 'Used', 'Other'];
export const TYRE_GRADES = ['New', 'Retread First Cap', 'Retread Second Cap', 'Retread Third Cap'];

export const WEAR_PATTERNS = [
  'Normal', 'Alignment Issue', 'Braking', 'Impact', 'Incorrect Pressure', 'Overloading', 'Suspension Problem', 'Uneven Shoulder', 'Other'
];

export const TYRE_REPAIR_TYPES = [
  'Plug and Patch', 'Internal Patching', 'External Plugging', 'Sealant/Aerosol', 'Section Repair',
  'Reinforcement Repair', 'Hot Vulcanization', 'Cold Vulcanization', 'Tube', 'Regrooving',
  'Accident', 'Other'
];

export const SERVICE_DELIVERY_OPTIONS = [
  'On-Site / Field Service', 'Roadside Assistance', 'In-Shop Retreading', 'Other'
];

export const TYRE_DAMAGE_SEVERITIES = [
  'Puncture', 'Heel & Toe Wear', 'Irregular Tread Wear', 'Centre Wear', 'Camber Wear', 'Bulges',
  'Cuts or Tears', 'Sidewall Dimples', 'Cracks', 'Blowouts', 'Bead Repair', 'Abrasion', 'Ageing', 'Other'
];

// Used by the association actions (fit / remove / rotate) in the next phase.
export const REMOVE_REASONS = ['Worn out', 'Damaged', 'Rotation', 'Retread', 'Inspection', 'Sold', 'Other'];
